export default __webpack_public_path__ + "assets/media/car.12ca75f9.png";